<template>
  <div class="container my-register">
    <div class="container-flex my-register-container">
      <img src="../../picture/register/register-bg.png" class="register-bg" />
      <div class="my-register-info" @click="goRegisterInfo">
        <div class="my-register-name">您的积分余额</div>
        <div class="my-register-value">{{ pointsData.points || 0 }}</div>
      </div>
      <div class="register-centent">
        <div class="register-operation">
          <div class="register-month">{{ timeYearMonth }}</div>
          <div class="register-btn" @click="registerClick">
            <img
              src="../../picture/register/btn.png"
              v-if="!isToday"
              class="register-btn-icon"
            />
            <img
              src="../../picture/register/btn-default.png"
              v-else
              class="register-btn-icon"
            />
          </div>
          <div class="register-tips">连续签到可以获得更多奖励哦</div>
        </div>
        <div class="time-content">
          <div class="time-list time-week-list">
            <div
              class="time-item"
              v-for="(item, index) in weekList"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="time-list">
            <div
              class="time-item"
              :class="dayTimeClassName[item.type]"
              v-for="(item, index) in signInListVos"
              :key="index"
            >
              <div class="time-info-box">
                <div class="time-info v-center">
                  <div
                    class="time-register"
                    v-if="
                      item.type == dayTimeType['old-active'] ||
                      item.type == dayTimeType['new-active']
                    "
                  >
                    <img
                      src="../../picture/register/register-yes.png"
                      class="register-yes"
                    />
                  </div>
                  <div
                    class="time-register"
                    v-else-if="
                      item.type == dayTimeType['old-no'] ||
                      item.type == dayTimeType['new-invalid']
                    "
                  >
                    {{
                      item.dayType == "next" && item.points
                        ? "+" + item.points
                        : "未签到"
                    }}
                  </div>
                  <div class="time-register" v-else>
                    {{ item.points ? "+" + item.points : "" }}
                  </div>
                </div>
                <div
                  class="time-value"
                  :class="item.time == toDay ? 'today' : ''"
                >
                  {{ item.time == toDay ? "今天" : item.time }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="register-centent register-explain-content">
        <div class="register-explain-title">签到规则</div>
        <div class="register-explain-p">
          1、连续签到 第一天得1分，第二天得2分，依次类推，第七天得7分。
        </div>
        <div class="register-explain-p">
          2、连续签到大于7天，得分与第七天一致
        </div>
        <div class="register-explain-p">
          3、中途若签到中断 ，则从第一天重新开始计算。
        </div>
      </div>
    </div>
    <van-popup v-model="popupShow">
      <div class="register-success">
        <div class="register-success-content">
          <img
            class="success-icon"
            src="../../assets/integral-icon/register-success.png"
            alt=""
          />
          <div class="register-success-tips">
            已经成功连续签到{{ signInSuccess.signInDay }}天
          </div>
          <div class="register-add-integral" v-if="signInSuccess.points">
            恭喜你，获得{{ signInSuccess.points }}积分
          </div>
        </div>
        <div class="close" @click="closePopup">
          <img
            class="close-icon"
            src="../../assets/integral-icon/close.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from "vant";
import {
  getUserPoints,
  getPointsSignIn,
  savePointsSignIn,
  getPointsSignInTime,
} from "../../common/api";

export default {
  name: "my-register",
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      popupShow: false,
      pointsData: {},
      keepSignInTimes: 0, // 连签次数
      signInListVos: [], // 签到列表
      loading: false,
      signInSuccess: {},
      toDay: "", // 今天
      isToday: false, // 今天是否签到
      timeYearMonth: "",
      dayList: [],
      weekList: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      dayTimeType: {
        "old-active": "1", // 上个月已签到
        "old-no": "2", // 上/下个月未签到
        "new-active": "3", //  当月已签到
        "new-no": "4", //当月未签到
        "new-invalid": "5", //当月已过期
      },
      dayTimeClassName: {
        1: "old-active", // 上个月已签到
        2: "old-no", // 上/下个月未签到
        3: "new-active", //  当月已签到
        4: "new-no", //当月未签到
        5: "new-no", //当月未签到
      },
    };
  },
  mounted() {
    let time =
      this.$common.thisTimes("mm") + "-" + this.$common.thisTimes("dd");
    this.toDay = time;
    this.timeYearMonth =
      this.$common.thisTimes("yy") + "-" + this.$common.thisTimes("mm");
    this.getUserPoints();
    this.getPointsSignIn();
  },
  methods: {
    
    async registerClick() {
      this.loading = true;
      let ret = await savePointsSignIn({
        chargeUserPkId: this.$route.query.chargeUserPkId,
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.signInSuccess = ret.data[0] || {};
        this.popupShow = true;
        setTimeout(() => {
          this.getPointsSignIn();
          this.getUserPoints();
        }, 1000);
      } else {
        this.$toast(ret.msg);
      }
      this.loading = false;
    },
    closePopup() {
      this.popupShow = false;
    },
    /**
     * 获取积分
     */
    async getUserPoints() {
      let ret = await getUserPoints({});
      if (ret.status === this.$config.ajaxStatus) {
        let data = ret.data[0];
        this.pointsData = data;
      } else {
        this.$toast(ret.msg);
      }
    },
    /**
     * 获取签到日期
     */
    async getPointsSignIn() {
      let ret = await getPointsSignIn({
        chargeUserPkId: this.$route.query.chargeUserPkId,
      });
      if (ret.status === this.$config.ajaxStatus) {
        let data = ret.data[0] || {};
        let signInListVos = data.signInListVos || [];
        this.keepSignInTimes = data.keepSignInTimes || 0;
        // 获取当前月是否有不在当前活动的日期已经签到
        let hisData = await this.getPointsSignInTime(signInListVos);
        let allData = [
          ...hisData,
          ...signInListVos
        ]
        this.signInListVos = this.getTimeList(allData);
      } else {
        this.$toast(ret.msg);
      }
    },
    /**
     *  获取不在当前活动的日期是否有签到
     */
    async getPointsSignInTime(signInListVos) {
      return new Promise(async(resolve) => {
        let getData = this.getPointsSignInData(signInListVos);
        // 数据的第一组 和  日历是第一天对比  ，第一组大于 日历第一天 就请求；
        if(getData.startTime){
          let ret = await getPointsSignInTime(getData);
          if (ret.status === this.$config.ajaxStatus) {
            let data = ret.data || [];
            data.map(item=>{
              item.time = this.getTimeReplace(item.time);
            })
            resolve(data);
          } else {
            resolve([]);
          }
        }else{
          resolve([]);
        }
      })
    },
    /**
     * 获取历史签到的请求参数，如果不需要请求历史签到则返回空
     */
    getPointsSignInData(signInListVos) {
      let year = this.$common.thisTimes("yy");
      
      let lastMonth = this.getLastMonth(signInListVos,'-');
      // 数据的第一组 和  日历是第一天对比  ，第一组大于 日历第一天 就请求；  或者当前活动数组出错了返回了个空
      if(signInListVos[0] && this.getTimeReplace(signInListVos[0].time) > lastMonth[0].time || !signInListVos[0]){
        let startTime = '';
        // 当前显示有上个月就是第一个，没有上个月的日期就使用当前月的第一天
        if(lastMonth[0]){
          startTime = year + '-' + lastMonth[0].time;
        }else{
          startTime = this.$common.thisTimes("yyyy-MM") + '01';
        }

        let endTime = "";
        if (signInListVos[0] && signInListVos[0].time) {
          endTime = year + "-" + this.getTimeReplace(signInListVos[0].time,'-');
        } else {
          endTime = this.$common.thisTimes("yyyy-MM-dd");
        }
        endTime = this.getNextDate(endTime,-1)
        return {
          startTime: startTime,
          endTime: endTime,
        }
      }else{
        return {}
      }
    },
    /**
     * JS获取指定日期的前一天，后一天  前 +1 / 后 -1
     */
    getNextDate(date, day) { 
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    
    /**
     * 去积分记录页面
     */
    goRegisterInfo() {
      this.$router.push({
        name: "my-integral-info",
        query: { chargeUserPkId: this.$route.query.chargeUserPkId },
      });
    },
    /**
     * 把 03月08日  转成 03-08  03.08 这样的格式
     */
    getTimeReplace(time) {
      return time.replace(/月/g, '-').replace(/日/g, "");
    },
    /**
     * 处理签到日期列表数据，把列表合并到日历里
     * @param {*} signInListVos
     * @returns
     */
    getTimeList(signInListVos) {
      signInListVos.map((item) => {
        item.time = this.getTimeReplace(item.time);
        if (item.time == this.toDay) {
          this.isToday = item.value;
        }
      });

      var t = this.timeYearMonth.split("-");
      let dayList = [];
      // 上个月
      dayList.unshift(...this.getLastMonth(signInListVos))

      // 这个月， 签到信息合并到 日历里
      const month = new Date(Number(t[0]), Number(t[1]), 0).getDate(); // 当月有几天
      for (let i = 1; i <= month; i++) {
        let time = t[1] + "-" + this.nameStr(i);
        dayList.push(this.forMonth(signInListVos, time, "new"));
      }

      // 下个月
      let weed = new Date(this.timeYearMonth + "-" + month).getDay(); //最后一天 星期几
      let m = this.nameStr(Number(t[1] == 12 ? 0 : t[1]) + 1);
      for (let i = 1; i <= 7 - weed; i++) {
        let time = m + "-" + this.nameStr(i) + "";
        dayList.push(this.forMonth(signInListVos, time, "next"));
      }

      return dayList;
    },
    /**
     * 获取上个月的数据，只取本月第一天前面空白的日期
     */
    getLastMonth(signInListVos) {
      // 上个月
      let dayList = [];
      var t = this.timeYearMonth.split("-");
      var d = new Date(this.timeYearMonth);
      let dayNull = d.getDay(); // 星期几
      if (dayNull === 0) {
        dayNull = 7;
      }
      let mm = (t[1] == 1 ? 13 : t[1]) - 1; // 上个月是几月
      const monthDay = new Date(Number(t[0]), Number(mm), 0).getDate(); // 上月有几天
      for (let i = 1; i < dayNull; i++) {
        let time = this.nameStr(mm) + '-' + (monthDay - (i - 1));
        dayList.unshift(this.forMonth(signInListVos, time, "old"));
      }
      return dayList;
    },
    /**
     * 数字补 0
     * @param {*} val
     * @returns
     */
    nameStr(val) {
      var value = val + "";
      if (val < 10) {
        value = "0" + val;
      }
      return value;
    },
    /**
     * 处理日历的每条数据，用日期去循环接口返回的列表，日期相应的数据就合并到日历的每天
     * @param {*} signInListVos 接口返回的签到列表
     * @param {*} time 当前这条日历数据的时间
     * @param {*} dayType 上/当前/下 个月
     * @returns
     */
    forMonth(signInListVos, time, dayType) {
      let itemData = signInListVos.filter((vos) => {
        return vos.time == time;
      });
      let item = itemData[0] || {};
      let type = "";
      if (dayType == "old" || dayType == "next") {
        type = item.value
          ? this.dayTimeType["old-active"]
          : this.dayTimeType["old-no"];
      } else {
        type = item.value
          ? this.dayTimeType["new-active"]
          : this.toDay > time
          ? this.dayTimeType["new-invalid"]
          : this.dayTimeType["new-no"];
      }
      return {
        time: time,
        type: type,
        dayType: dayType,
        ...item,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.my-register {
  .my-register-container {
    background-color: #14cc80;
    padding: 0.2rem;
    position: relative;
  }
  .register-bg {
    position: absolute;
    width: 100%;
    height: 2.99rem;
    top: 0;
    left: 0;
  }
  .my-register-info {
    padding: 0.17rem 0 0.71rem 0;
    text-align: center;
    color: #fff;
  }
  .my-register-info .my-register-name {
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .my-register-info .my-register-value {
    font-size: 0.5rem;
    line-height: 0.6rem;
    margin-top: 0.05rem;
  }
  .register-centent {
    background: #ffffff;
    border-radius: 0.16rem;
    border: 0.04rem solid rgba(255, 255, 255, 0.4);
  }
  .register-operation {
    background: linear-gradient(180deg, #fcfcfc 0%, #ededed 100%);
    border-radius: 0.16rem 0.16rem 0px 0px;
    text-align: center;
    color: #666666;
    height: 3.14rem;
  }
  .register-operation .register-month {
    padding: 0.2rem 0 0.18rem;
    font-size: 0.34rem;
    line-height: 0.48rem;
  }
  .register-operation .register-btn {
    width: 2.84rem;
    height: 0.94rem;
    margin: auto;
    margin-top: 0.41rem;
  }
  .register-operation .register-btn .register-btn-icon {
    width: 100%;
    height: 100%;
  }
  .register-operation .register-tips {
    margin-top: 0.2rem;
    font-size: 0.24rem;
    line-height: 0.33rem;
  }
  .time-content {
    padding: 0.3rem 0.2rem;
  }
  .time-list {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
  }
  .time-list .time-item {
    font-size: 0.18rem;
    line-height: 0.25rem;
    color: #949494;
    width: 14.25%;
    box-sizing: border-box;
  }
  .time-week-list .time-item {
    padding: 0.1rem 0;
  }
  .time-list .time-item .time-info-box {
    border-right: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    padding: 0.1rem 0;
    color: #949494;
    font-size: 0.18rem;
    line-height: 0.25rem;
  }
  .time-list .time-item .time-info-box .time-info {
    width: 0.6rem;
    height: 0.6rem;
    border: 0.01rem solid #c2c2c2;
    box-sizing: border-box;
    border-radius: 50%;
    margin: auto;
  }
  /*上月的已签到*/
  .time-list .time-item.old-active .time-info-box .time-info {
    background: #c2c2c2;
  }
  /*上月/下月 的未签到*/
  .time-list .time-item.old-no .time-info-box .time-info {
    color: #c2c2c2;
  }
  /* 当月的已签到 */
  .time-list .time-item.new-active .time-info-box .time-info {
    background: linear-gradient(
      270deg,
      rgba(3, 240, 178, 0.5) 0%,
      rgba(3, 240, 178, 0.5) 100%
    );
    box-shadow: 0px 0px 0.02rem 0px rgba(3, 240, 178, 0.3),
      inset 0px 0px 0.03rem 0px rgba(255, 255, 255, 0.4),
      inset 0px 0px 0.03rem 0px rgba(0, 226, 255, 0.6);
    border: 0px solid;
    border-image: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0.6),
        rgba(255, 255, 255, 0.2)
      )
      0 0;
    backdrop-filter: blur(0.03rem);
  }
  /* 当月的未签到 */
  .time-list .time-item.new-no .time-info-box .time-info {
    color: #666;
    border-color: #666;
  }
  .time-list .time-item .time-info-box .time-info .register-yes {
    width: 0.39rem;
    height: 0.29rem;
  }
  .time-list .time-item .time-value {
    margin-top: 0.05rem;
  }
  .time-list .time-item .time-value.today {
    color: #000;
  }
  .register-explain-content {
    font-size: 0.24rem;
    line-height: 0.33rem;
    color: #666666;
    padding: 0.2rem;
    margin-top: 0.16rem;
  }
  .register-explain-content .register-explain-title {
    color: #333;
  }
  .register-explain-content .register-small-title {
    margin-top: 0.2rem;
  }
  .register-explain-content .register-small-title-2 {
    margin-top: 0.4rem;
  }
  .van-popup {
    background: transparent;
  }
  .register-success {
    width: 6.7rem;
    height: 5.5rem;
    border-radius: 0.1rem;

    .register-success-content {
      text-align: center;
      background-color: #fff;
      height: 4rem;
      margin-top: 1.63rem;
      position: relative;
      .success-icon {
        margin-top: -1.63rem;
        width: 3.66rem;
        height: 3.26rem;
        vertical-align: top;
      }
      .register-success-tips {
        margin-top: 0.33rem;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #666;
      }
      .register-add-integral {
        margin-top: 0.3rem;
        font-size: 0.38rem;
        line-height: 0.53rem;
        color: #333;
      }
    }
    .close {
      margin-top: 0.6rem;
      text-align: center;
      .close-icon {
        width: 0.7rem;
        height: 0.7rem;
      }
    }
  }
}
</style>
